<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { AvatarRoot } from 'radix-vue'
import { type AvatarVariants, avatarVariant } from '.'

const props = withDefaults(defineProps<{
	class?: HTMLAttributes['class']
	size?: AvatarVariants['size']
	shape?: AvatarVariants['shape']
}>(), {
	size: 'sm',
	shape: 'circle',
})
</script>

<template>
	<avatar-root :class="cn(avatarVariant({ size, shape }), props.class)">
		<slot />
	</avatar-root>
</template>
